import React from "react";
import { Box } from "@mui/material";
import LevelDevice from "./Devices/LevelDevice";
import parseNumber from "../../../../utils/parseCalculate";
import { useLiveDevice } from "../../../../hooks/useLiveDeviceData";
import { formatLevelTransmitterDashboardDateTime } from "../../../../utils/levelTransmitterDateTime";
import { transmitterFillPercent } from "../../../../utils/levelTransmitterRange";

function Item(props) {
  const { sx, ...other } = props;
  return <Box {...other} />;
}

const TankContainer = (props) => {
  const { data, units, status } = useLiveDevice(
    props.isExpired ? null : props.deviceId,
    { watchStatus: true }
  );
  const deviceStatus = props.isExpired ? "inactive" : status;
  const levelValue = data ? parseNumber(data.level) : "--";
  const levelUnit = units.level_unit || props.levelUnit || "m";
  const rangeMaxMeters = units.level_range_max_m ?? props.levelRangeMaxM;

  return (
    <Item>
      <LevelDevice
        deviceStatus={deviceStatus}
        powerStatus={data?.battery == null ? null : Number(data.battery)}
        deviceId={props.deviceId}
        lastUpdated={
          props.isExpired ? "" : data?.date_time
            ? props.deviceType === "level_transmitter"
              ? formatLevelTransmitterDashboardDateTime(data.date_time)
              : `${new Date(data.date_time).toLocaleDateString("en-GB")} ${new Date(data.date_time).toLocaleTimeString("en-US", { hour12: true })}`
            : "--"
        }
        levelValue={
          props.isExpired
            ? "Subscription Expired"
            : `${levelValue} ${levelUnit}`
        }
        title={props.name}
        deviceType={props.deviceType}
        fillPercent={props.isExpired || !data ? null : transmitterFillPercent(data.level, levelUnit, rangeMaxMeters)}
      />
    </Item>
  );
};

export default TankContainer;
